module.exports = __webpack_public_path__ + "img/logo_white.44cb1bb2.png";